import { createContext } from 'react';

export interface SearchContextData {
  busca: string;
  setBuscaState: (value: string) => void;
}

export const SearchContext = createContext<SearchContextData>({} as SearchContextData);
